<template>
  <v-container fluid>
    <v-expansion-panels>
      <v-expansion-panel v-for="(account, index) in tableData" :key="index">
        <v-expansion-panel-header>
          <div class="d-flex align-center">
            <span>Account: {{ account.account_number }} ({{ account.account_type }}, {{ account.currency || "Unknown currency" }})</span>
            <v-btn
              icon
              small
              @click.stop="openEditDialog(index)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            :headers="headers"
            :items="account.transactions"
            :items-per-page="-1"
            :disable-pagination="true"
            hide-default-footer
            class="elevation-1"
          >
            <template v-slot:item.deposit="{ item }">
              {{ formatCurrency(item.deposit, account.currency) }}
            </template>
            <template v-slot:item.withdrawal="{ item }">
              {{ formatCurrency(item.withdrawal, account.currency) }}
            </template>
            <template v-slot:item.balance="{ item }">
              {{ formatCurrency(item.balance, account.currency) }}
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Edit Dialog -->
    <v-dialog v-model="editDialog" max-width="500px">
      <v-card>
        <v-card-title>Edit Account</v-card-title>
        <v-card-text>
          <v-form ref="editForm" v-model="valid" lazy-validation>
            <v-text-field
              v-model="editedAccount.account_number"
              label="Account Number"
            ></v-text-field>
            <v-text-field
              v-model="editedAccount.account_type"
              label="Account Type"
            ></v-text-field>
            <v-text-field
              v-model="editedAccount.currency"
              label="Currency"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeEditDialog">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="updateValue" :disabled="!valid">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  props: {
    taskId: {
      type: Number,
      required: true
    },
    tableData: {
      type: Array,
      required: true
    },
    fetchResult: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      headers: [
        { text: 'Date', value: 'date' },
        { text: 'Type', value: 'type' },
        { text: 'Description', value: 'desc' },
        { text: 'Deposit', value: 'deposit' },
        { text: 'Withdrawal', value: 'withdrawal' },
        { text: 'Balance', value: 'balance' },
        { text: 'Related Client', value: 'related_to_client' },
        { text: 'Related Supplier', value: 'related_to_supplier' }
      ],
      editDialog: false,
      valid: true,
      editedAccount: {
        account_number: '',
        account_type: '',
        currency: ''
      },
      editedIndex: -1
    }
  },
  methods: {
    formatCurrency(value, currency) {
      if (!value) return ''
      try {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(
          parseFloat(value.toString().replace(/,/g, ''))
        )
      } catch (error) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: "HKD", currencyDisplay: "narrowSymbol" }).format(
          parseFloat(value.toString().replace(/,/g, ''))
        )
      }
    },
    openEditDialog(index) {
      this.editedIndex = index
      this.editedAccount = { 
        account_number: this.tableData[index].account_number,
        account_type: this.tableData[index].account_type,
        currency: this.tableData[index].currency
      }
      this.editDialog = true
    },
    closeEditDialog() {
      this.editDialog = false
      this.$refs.editForm.resetValidation()
      this.editedAccount = {
        account_number: '',
        account_type: '',
        currency: ''
      }
      this.editedIndex = -1
    },
    async updateValue() {
      if (this.$refs.editForm.validate()) {
        try {
          for (let infoKey in this.editedAccount) {
            const updatedField = JSON.stringify(['processed_bank_statement', 'account_transaction', this.editedIndex, infoKey])
            await this.$http.post(`/api/tasks/${this.taskId}/update_value`, {
              field: updatedField,
              value: this.editedAccount[infoKey],
              skip_reprocess: 1
            })
          }
          this.editDialog = false
          await this.fetchResult() // Refresh the table data
          alert('Statement information updated successfully')
        } catch (error) {
          console.error('Error updating statement info:', error)
          alert('Failed to update statement information')
        }
      }
    },
  }
}
</script>
